import axios from "axios";

// The do-chat API as the chat calls it: with its sign-in ticket, once it has one.
export const chatHttp = axios.create();

let chatTicket: string | null = null;

export function setChatTicket(ticket: string | null) {
  chatTicket = ticket;
}

chatHttp.interceptors.request.use((config) => {
  if (chatTicket) config.headers.set("Authorization", `Bearer ${chatTicket}`);
  return config;
});
